import { DialogActions } from '@material-ui/core';

import { bind } from 'bind-decorator';

import { Button } from 'bz-core-controls';

import type { IBaseProps } from 'bz-core-controls/modal-new/confirmation';
import React from 'react';

export interface IProps extends Pick<IBaseProps, 'actionProps'> {
  className: string;
  label: string;

  onClick: () => void;
}

class AlertActions extends React.Component<IProps> {
  render() {
    const { actionProps, className, label } = this.props;

    return (
      <DialogActions {...actionProps} className={`${className} actions`}>
        <Button
          className={`${className} btn-ok`}
          label={label}
          primary={true}
          onClick={this.onClick}
        />
      </DialogActions>
    );
  }

  @bind
  private onClick(e: React.MouseEvent<any>): void {
    this.props.onClick();
  }
}

export default AlertActions;
